/**
 * Curated recipe pack UI telemetry (ProductUiEvent via trackUiEvent).
 * Event contract: docs/TELEMETRY_SCHEMA.md § Product UI events (recipe packs).
 */

import { trackUiEvent } from './uiAnalytics.js'

export const RECIPE_PACK_SURFACES = {
  COOK_ADD: 'cook_add',
  COOK_BROWSE: 'cook_browse',
  PLANNER_COLD_START: 'planner_cold_start',
  PLANNER_THIN_LIBRARY: 'planner_thin_library',
}

const SHELF_VIEWED_SESSION_KEY = 'recipe_pack_shelf_viewed_v1'

/**
 * @param {string} event
 * @param {Record<string, string|number|boolean|null|undefined>} [properties]
 */
export function trackRecipePackEvent(event, properties = {}) {
  trackUiEvent(event, {
    feature_area: 'recipe_packs',
    ...properties,
  })
}

/**
 * @param {{ id?: string, slug?: string } | null | undefined} pack
 */
export function packTelemetryIds(pack) {
  const id = pack?.id || pack?.slug || null
  const slug = pack?.slug || pack?.id || null
  return {
    pack_id: id,
    pack_slug: slug,
  }
}

/**
 * Fire recipe_pack_shelf_viewed at most once per surface per browser tab session.
 *
 * @param {string} surface
 * @param {Record<string, string|number|boolean|null|undefined>} properties
 * @param {{ current?: Set<string> }} [viewedRef] optional in-memory dedupe (per component)
 */
export function trackRecipePackShelfViewedOnce(surface, properties = {}, viewedRef) {
  const key = `${surface}:${properties.pack_count ?? 0}`
  if (viewedRef?.current) {
    if (viewedRef.current.has(key)) return
    viewedRef.current.add(key)
  } else {
    try {
      const raw = sessionStorage.getItem(SHELF_VIEWED_SESSION_KEY)
      const seen = new Set(JSON.parse(raw || '[]'))
      if (seen.has(key)) return
      seen.add(key)
      sessionStorage.setItem(SHELF_VIEWED_SESSION_KEY, JSON.stringify([...seen]))
    } catch {
      // ignore storage errors
    }
  }
  trackRecipePackEvent('recipe_pack_shelf_viewed', {
    surface,
    ...properties,
  })
}

export function plannerPackSurfaceFromMode(mode) {
  return mode === 'hero'
    ? RECIPE_PACK_SURFACES.PLANNER_COLD_START
    : RECIPE_PACK_SURFACES.PLANNER_THIN_LIBRARY
}
